module.exports = __webpack_public_path__ + "static/media/preRecordedCourses.d9b203f1.png";